import React, { useState } from 'react'
import styled from 'styled-components'
import { ReactSVG } from 'react-svg'

import liveIcon from '../../../assets/mainScreen/liveIcon.svg'
import planIcon from '../../../assets/mainScreen/planIcon.svg'
import progressIcon from '../../../assets/mainScreen/progressIcon.svg'
import trenningIcon from '../../../assets/mainScreen/trenningIcon.svg'
import settingsIcon from '../../../assets/mainScreen/settingsIcon.svg'
import calculatorIcon from '../../../assets/mainScreen/calculator.svg'
import chatIconSvg from '../../../assets/mainScreen/chaticonSvg.svg'
import waterIcon from '../../../assets/waterReminder/water.svg'
import { fontSizeResponsive, mediaQ } from '../../theme/mixins'

const NavigationBarContainer = styled.div`
  height: 11.5vh;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.16);

  border-bottom: ${(props) =>
    props.isNavDropdownVisible ? '1px solid rgba(0, 0, 0, 0.16)' : 'unset'};
  display: flex;
  align-items: center;
  z-index: 2;
  background-color: white;

  ${mediaQ(
    'mobileAll',
    'position:fixed;bottom:0;height: 9.5vh;width: 100%;justify-content: space-around; z-index:2;'
  )};

  .settings {
    ${mediaQ('mobileAll', 'display: none')};
  }
`
const NavElement = styled.div`
  /* width: 100px;
  height: 150px; */
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  margin-left: ${(props) => (props.settings ? 'auto' : 'unset')};
  /* margin-right: ${(props) => (props.settings ? '4.4vw' : 'unset')}; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: flex-end; */
  div {
    display: flex;
    justify-content: center;
  }
  svg {
    width: 100%;
    height: 100%;
  }

  ${mediaQ('mobileAll', 'width:unset; padding:5px; margin: 0px;')};
`
export const SvgElement = styled(ReactSVG)`
  /* fill: linear-gradient(to bottom, #faae01, #fe0da0); */
  fill: #fe0d9f;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  #color1 {
    stop-color: #fe0d9f;
  }
  #color2 {
    stop-color: #fe0d9f;
  }
  opacity: ${(props) => (props.settings ? '1' : '0.5')};

  &:hover {
    #color1 {
      stop-color: #faae01;
    }
    #color2 {
      stop-color: #fe0da0;
    }
    opacity: 1;
    cursor: pointer;
  }
`
export const NavElementName = styled.span`
  font-family: 'Roboto';
  margin-top: 8px;
  ${fontSizeResponsive(16)}
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  display: flex;
  justify-content: center;
  white-space: nowrap;
`

const NavigationBar = ({
  onOpenMenuClick,
  isNavDropdownVisible,
  onSubpageChange,
  isPlayerActive,
  changeLocation,
}) => {
  return (
    <NavigationBarContainer isNavDropdownVisible={isNavDropdownVisible}>
      {!isPlayerActive && (
        <>
          <NavElement trenning onClick={() => changeLocation('/trening')}>
            <SvgElement src={trenningIcon} />
            <NavElementName>Trening</NavElementName>
          </NavElement>
          <NavElement trenning onClick={() => changeLocation('/diety')}>
            <SvgElement src={trenningIcon} />
            <NavElementName>Diety</NavElementName>
          </NavElement>
          <NavElement plan onClick={() => changeLocation('/plan-treningowy')}>
            <SvgElement src={planIcon} />
            <NavElementName>Plan</NavElementName>
          </NavElement>
          <NavElement progress onClick={() => changeLocation('/postepy')}>
            <SvgElement src={progressIcon} />
            <NavElementName>Postępy</NavElementName>
          </NavElement>
          <NavElement live onClick={() => changeLocation('/live')}>
            <SvgElement src={liveIcon} />
            <NavElementName>Live</NavElementName>
          </NavElement>
          <NavElement calculator className="calculator">
            <SvgElement
              src={calculatorIcon}
              calculator
              onClick={() => changeLocation('/kalkulator')}
            />
            <NavElementName>Kalkulator BMR</NavElementName>
          </NavElement>
          <NavElement calculator className="calculator">
            <SvgElement
              src={waterIcon}
              water
              onClick={() => changeLocation('/picie-wody')}
            />
            <NavElementName>Picie wody</NavElementName>
          </NavElement>
          {/* <NavElement plan onClick={() => changeLocation('/plan-treningowy')}>
            <SvgElement src={chatIconSvg} />
            <NavElementName>Chat</NavElementName>
          </NavElement> */}
          <NavElement settings className="settings">
            <SvgElement settings src={settingsIcon} onClick={onOpenMenuClick} />
            <NavElementName>Ustawienia</NavElementName>
          </NavElement>
        </>
      )}
    </NavigationBarContainer>
  )
}

export default NavigationBar
